import React from "react"

const ArrowheadFatDown = ({ className }) => (
	<svg width="14" height="9" className={className || ""} xmlns="http://www.w3.org/2000/svg">
		<path d="M7 5.586L1.707.293.293 1.707 7 8.414l6.707-6.707L12.293.293z" fillRule="evenodd" />
	</svg>
)

export default ArrowheadFatDown
